import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ConfigurationService } from '../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class FinancialpositionService {
  balanceSheetUrl = this.ConfigService.getAPIBaseUrl() + 'api/BalanceSheet/'

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  getBalanceSheet(APPeriodId) {
    return this.http.get(this.balanceSheetUrl + 'GetBalanceSheet?APPeriodId=' + APPeriodId);
  }
  getBalanceSheetFRS101(APPeriodId) {
    return this.http.get(this.balanceSheetUrl + 'GetBalanceSheetFRS101?APPeriodId=' + APPeriodId);
  }
}
